/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { SET_READY, REFRESH_LOCALE } from 'actions/app';

import {
  UPDATE_PASSWORD_REQUEST,
  UPDATE_PASSWORD_SUCCESS,
  UPDATE_PASSWORD_FAILURE,
} from 'actions/user';

import p from 'polyglot/polyglot';

const initialState = () => ({
  fieldsets: [
    {
      legend: '',
      inputs: [
        {
          type: 'password',
          name: 'password',
          label: p.t('new_password.form.password.label'),
          placeholder: p.t('new_password.form.password.placeholder'),
          description: p.t('new_password.form.password.description'),
          constraints: /^\S{6,}$/, // At least 6 characters and without any whitespace.
          required: true,
          colWidth: 8,
        },
        {
          type: 'password',
          name: 'password_confirm',
          label: p.t('new_password.form.password_confirm.label'),
          placeholder: p.t('new_password.form.password_confirm.placeholder'),
          description: p.t('new_password.form.password.description'),
          constraints: /^\S{6,}$/, // At least 6 characters and without any whitespace.
          required: true,
          colWidth: 8,
          mustMatch: 'password',
        },
      ],
    },
  ],
  validationMessages: {
    password: {
      invalid: p.t('new_password.form.password.invalid'),
    },
    password_confirm: {
      invalid: p.t('new_password.form.password_confirm.invalid'),
    },
    required: p.t('general.form.required'),
  },
  submitText: p.t('general.form.submit'),
  sending: false,
  errors: {},
});

/**
 * This is the createProfileForm reducer. It listens for actions and updates the createProfileForm object.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export default function(
  state = (state = {
    fieldsets: [
      {
        legend: '',
        inputs: [],
      },
    ],
    validationMessages: {},
    submitText: '',
    sending: false,
    errors: {},
  }),
  { type, payload }
) {
  switch (type) {
    case REFRESH_LOCALE:
    case SET_READY:
      return initialState();

    case UPDATE_PASSWORD_REQUEST:
      return {
        ...state,
        sending: true,
        errors: {},
      };

    case UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        sending: false,
        errors: {},
      };

    case UPDATE_PASSWORD_FAILURE:
      return {
        ...state,
        sending: false,
        errors: payload.errors || {}, // @TODO: FORMAT ERRORS!
      };

    default:
      return state;
  }
}
